export const VIRTUAL_LIST_ITEM_HEIGHT = {
    xs: 40,
    sm: 40,
    md: 48,
};
